<template>
  <Card :title="$t('claims.serviceCodeRequired.title')">
    <template v-slot:content>
      <p v-html="$t('claims.serviceCodeRequired.text')" class="mb-16"></p>
    </template>
    <template v-slot:footer>
      <div class="footer-cta footer-cta--left">
        <CustomButton
          @click="navigateToRequestServiceCode"
          :button-color="ButtonColor.PRIMARY"
          :button-type="ButtonType.BUTTON"
          button-id="requestServiceCode"
        >
          {{ $t('claims.serviceCodeRequired.primaryButton') }}
        </CustomButton>
        <CustomButton
          @click="navigateToEnterServiceCode"
          :button-color="ButtonColor.SECONDARY"
          :button-type="ButtonType.BUTTON"
          button-id="enterServiceCode"
        >
          {{ $t('claims.serviceCodeRequired.secondaryButton') }}
        </CustomButton>
      </div>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { Card, CustomButton, ButtonColor, ButtonType } from 'de-zurich-ui-library'
import { navigate } from '@/utils/NavigationUtils'

const navigateToRequestServiceCode = (): void => {
  navigate(
    globalThis.ENV_CONFIG?.SERVICE_LINKS.SETTINGS_PAGE.CHANGE_SERVICECODEREQUEST_PAGE
  )
}

const navigateToEnterServiceCode = (): void => {
  navigate(
    globalThis.ENV_CONFIG?.SERVICE_LINKS.SETTINGS_PAGE.CHANGE_SERVICECODEINPUT_PAGE
  )
}
</script>

<style scoped lang="scss">
.styled-list {
  list-style: disc;
  padding-left: 24px;

  li {
    margin-bottom: 8px;
  }
}

.mb-16 {
  margin-bottom: 16px;
}

.mb-32 {
  margin-bottom: 32px;
}
</style>
